import { render, staticRenderFns } from "./imageDialog.vue?vue&type=template&id=ae1130d6&scoped=true"
import script from "./imageDialog.vue?vue&type=script&lang=js"
export * from "./imageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1130d6",
  null
  
)

export default component.exports